// @file Opens native share mene
import { captureException } from 'bits/error_tracker'
import { browserCan } from './browser'

export const openNativeShare = async (data: ShareData): Promise<void> => {
  const canUseNativeShare = browserCan('share')
  if (!canUseNativeShare) {
    captureException(new Error('Attempted to call share when not available'))
    return
  }

  try {
    await window.navigator.share(data)
  } catch (error: any) {
    // We don't capture AbortError when the user canceled the share operation or there are no share targets available
    // @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/share#exceptions
    const ABORT_ERROR_CODE = 20
    if (error.code !== ABORT_ERROR_CODE) {
      captureException(error)
    }
  }
}
